/**
 * Logo Component
 * 
 * Happy Thumbs Co. branding logo
 * Used in question headers and thank you page
 */

import React from 'react';
import { motion } from 'framer-motion';

// ============================================
// TYPES
// ============================================

interface LogoProps {
  /** Size variant */
  size?: 'sm' | 'md' | 'lg';
  /** Whether to animate on mount */
  animate?: boolean;
  /** Custom class name */
  className?: string;
}

// ============================================
// COMPONENT
// ============================================

/**
 * Logo - Happy Thumbs Co. branding
 */
export const Logo: React.FC<LogoProps> = ({ 
  size = 'md', 
  animate = true,
  className = '' 
}) => {
  // Size configurations
  // 4x larger logo size - very prominent
  const sizeClasses = {
    sm: 'h-64 w-full max-w-question',
    md: 'h-80 w-full max-w-question',
    lg: 'h-96 w-full max-w-question',
  };

  const logoElement = (
    <img
      src="/happy-thumbs-logo.png"
      alt="Happy Thumbs Co."
      className={`${sizeClasses[size]} ${className} object-contain`}
      style={{ filter: 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15))' }}
    />
  );

  if (animate) {
    return (
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
        className="flex justify-center"
      >
        {logoElement}
      </motion.div>
    );
  }

  return <div className="flex justify-center">{logoElement}</div>;
};

Logo.displayName = 'Logo';

export default Logo;
